import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { concat, tap, of, Subscription, Subject } from 'rxjs';
import { map, switchMap, concatMap, debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { Person } from 'src/app/shared/person';
import { Client } from 'src/app/shared/client';
import { Document } from 'src/app/shared/document';

import { ClientApiService } from 'src/app/services/client-api.service';

@Component({
  selector: 'app-new-document-dlg-client-inventory',
  templateUrl: './new-document-dlg-client-inventory.component.html',
  styleUrls: ['./new-document-dlg-client-inventory.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NewDocumentDlgClientInventoryComponent implements OnInit, OnChanges, OnDestroy {

  @Input() parentDocument: Document;
  @Input() newDocument: Document;

  @Input() cliComLabel: string = 'Основная компания:';
  @Input() cliPerLabel: string = 'Ответственный в компании:';
  @Input() manDepLabel: string = 'Отдел инвентаризации:';

  @Input() pcoComLabel: string = 'Юридическое лицо:';
  @Input() pcoPerLabel: string = 'Ответственный от юрлица:';
  @Input() pcoDepLabel: string = 'Отдел инвентаризации юрлица:';

  private _cliCompanyQuery: Subscription;
  private _depChildQuery: Subscription;

  cliCompany: Client;
  pcoCompany: Client;
  cliPerson: Person;
  pcoPerson: Person;

  private cliCompanySubs$ = new Subject<number>();

  parentDocumentId: number;

  selectDepartmentOn: boolean = true;   // Just to keep compatibility (kind of)

  private _newDocumentUpdateQuery: Subscription = null;

  private newDocumentUpdateSubs$ = new Subject<Document>();
  @Output() newDocumentUpdate: EventEmitter<Document> = new EventEmitter();
  constructor(
    private cliApi: ClientApiService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** NewDocumentDlgClientInventoryComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** NewDocumentDlgClientInventoryComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** NewDocumentDlgClientInventoryComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {

        case 'parentDocument':
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** NewDocumentDlgClientInventoryComponent in ngOnDestroy')

    if (this._cliCompanyQuery) { this._cliCompanyQuery.unsubscribe(); }
    if (this._depChildQuery) { this._depChildQuery.unsubscribe(); }
    if (this._newDocumentUpdateQuery) { this._newDocumentUpdateQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** NewDocumentDlgClientInventoryComponent in ngOnInit');

    this._newDocumentUpdateQuery =
      this.newDocumentUpdateSubs$.pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(document => environment.production || console.log('*** NewDocumentDlgCompaniesComponent newDocumentUpdateSubs$: ' + JSON.stringify(document))),
        map(document => this.newDocumentUpdate.emit(document)),
      )
        .subscribe();

    this._cliCompanyQuery =
      this.cliCompanySubs$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(cli => this.cliApi.getClientById(cli).pipe(map(data => {
          console.log('*** NewDocumentDlgClientInventoryComponent cliCompanySubs$: ' + JSON.stringify(data));

          this.cliCompany = data[0];

          if (this.newDocument && this.cliCompany && this.cliCompany.CURID) {
            this.newDocument.DOCCURRID = this.cliCompany.CURID;
            this.newDocumentUpdateSubs$.next(this.newDocument);
          }
        })))
      )
        .subscribe();
  }

  cliCompanySelected(event) {
    console.log('*** NewDocumentDlgClientInventoryComponent cliCompanySelected  ' + JSON.stringify(event));
    this.newDocument.DOCCLIENTSID = event;
    this.newDocument.DOCPCOCLIID = event;

    this.cliCompanySubs$.next(this.newDocument.DOCCLIENTSID);
  }

  mainStockSelected(selectedId) {
    console.log('*** CreateNewDocumentComponent in mainStockSelected: ' + selectedId);

    this.newDocument.DOCMANDEPID = selectedId;
    this.newDocument.DOCCLIDEPID = selectedId;

    this._depChildQuery =
      this.cliApi.getChildDepartmentsById(this.newDocument.DOCMANDEPID, this.newDocument.DOCLCOCLIID)
        .pipe(map(data => {
          this.newDocument.DOCLCODEPID = data[0].CLIID;
          this.newDocument.DOCPCODEPID = data[0].CLIID;
          this.newDocumentUpdateSubs$.next(this.newDocument);
        }))
        .subscribe();
  }

  cliPersonSelected(event) {
    console.log('*** NewDocumentDlgClientInventoryComponent cliPersonSelected  ' + JSON.stringify(event));
    this.newDocument.DOCPERSONID = event;
    this.newDocumentUpdateSubs$.next(this.newDocument);
  }

  pcoCompanySelected(event) {
    console.log('*** NewDocumentDlgClientInventoryComponent pcoCompanySelected  ' + JSON.stringify(event));

    this._depChildQuery = of(event).pipe(
      concatMap(ndi => { this.newDocument.DOCPCOCLIID = event; return of(this.newDocument); }),

      concatMap(ndi => this.cliApi.getChildDepartmentsById(ndi.DOCCLIDEPID, ndi.DOCPCOCLIID).pipe(map(d => {

        this.newDocument.DOCPCODEPID = ((d || []).length > 0) ? d[0].CLIID : ndi.DOCCLIDEPID;

        return this.newDocument;
      }))),

      concatMap(ndi => this.cliApi.getPersonsByClientId(ndi.DOCPCOCLIID).pipe(map(prs => {

        let dir: Person =
          prs
            .sort((a, b) => {     // Note! Reverse sort order
              if (a.PERSRESPONSIBLE > b.PERSRESPONSIBLE) { return -1; }
              if (a.PERSRESPONSIBLE < b.PERSRESPONSIBLE) { return 1; }
              return 0;
            }
            )
            .find(pr => pr.PERSRESPONSIBLE > 0);
        if (dir) {
          this.newDocument.DOCPCOPERID = dir.PERSID;
        } else
          if (prs.length > 0) {
            this.newDocument.DOCPCOPERID = prs[0].PERSID;
          }

        this.newDocumentUpdateSubs$.next(this.newDocument);
        return this.newDocument;
      })))
    )
      .subscribe();
  }

  pcoPersonSelected(event) {
    console.log('*** NewDocumentDlgClientInventoryComponent pcoPersonSelected  ' + JSON.stringify(event));
    if (event) {
      this.newDocument.DOCPCOPERID = event;
      this.newDocumentUpdateSubs$.next(this.newDocument);
    }
  }

  pcoStockSelected(selectedId) {
    console.log('*** CreateNewDocumentComponent in childStockSelected: ' + selectedId);

    /*
     * TODO: In general it is not good idea to select the LCO department
     * 
     * it usually selected by Main Department
     */
    this.newDocument.DOCLCODEPID = selectedId;
    this.newDocument.DOCPCODEPID = selectedId;
    this.newDocumentUpdateSubs$.next(this.newDocument);
  }
}
